// Modules
import { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

// CSS
import '_Asset/css/User/Page/develop.css'

// Component
import { KmList } from "User/Component"

// API
import { KmListApi } from '_Route/Api';


const APIManual = () => {

  const navigate = useNavigate();

  // const [popupState, setPopUpState] = useState(false);

  const basicLimit = 5;
  const [showDataNum, setShowDataNum] = useState(basicLimit);
  const [recentData, setRecentData] = useState([]);

  useEffect(() => {
    axios.get(KmListApi)
    .then(res => {
      // 마지막 수정 날짜 순 내림차순 정렬
      const dateDesc = res.data.result.sort((a, b) => {
        let x = new Date(a.km_last_modify_date);
        let y = new Date(b.km_last_modify_date);
        return y - x;
      })
      setRecentData(dateDesc);
    })
    .catch(err => {
      console.error("ERROR", err)
    })
  }, [])
  

  const [searchVal, setSearchVal] = useState('');
  
  const onChangeSearch = useCallback(e => {
    setSearchVal(e.target.value);
  }, []);
  
  const onKeyPress = (e) => { if(e.key == 'Enter') onSearch(); }
  const onSearch = () => {
    if (searchVal.length < 2) { 
      alert('검색어를 두글자 이상 입력해주세요.')
    } else {
      navigate(`/develop/apis-manual/search${searchVal === '' ? '' : '/' + encodeURIComponent(searchVal)}`);
    }
  }

  
  return (
    <>
      {/* Visual */}
      <div className="visual develop center">
        <div className="section">
          <div className="visualTitGroup">
            <h2 className="visualTit center">Seyfert KM</h2>

            <fieldset>
              <legend>콘텐츠 검색</legend>

              <div className="fieldGroup row mainSearch">
                <div className="field">
                  <input type="input" className="input lg" placeholder='검색할 메뉴를 입력해주세요.' onChange={onChangeSearch} onKeyPress={onKeyPress} />
                  <button type="button" className="btn md sfrtBlue i_only" onClick={onSearch}><i className="icofont-search"></i></button>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>

      <div className="mainContents">
        <div className="section">
          <div className="dashBoardArea areaBox">
            <div className="kmTitGroup">
              <div className="flexBox between">
                <h2><i className="icofont-dashboard-web"></i>Seyfert KM Dashboard</h2>
                
                {/* Pop Up [임시 주석] */}
                {/* <button type="button" className="icofont-navigation-menu" onClick={() => setPopUpState(!popupState)}></button>
                <div className={`popUpBox ${popupState ? 'active' : ''}`}>
                  <ul>
                    <li><Link to="">Attachments (0)</Link></li>
                    <li><Link to="">Page History</Link></li>
                    <li><Link to="">Restrictions</Link></li>

                    <li><Link to="">Page Information</Link></li>
                    <li><Link to="">Resolved comments (0)</Link></li>
                    <li><Link to="">Link to this Page...</Link></li>
                    <li><Link to="">View in Hierarchy</Link></li>
                    <li><Link to="">View Source</Link></li>
                    <li><Link to="">Export to PDF</Link></li>
                    <li><Link to="">Export to Word</Link></li>
                  </ul>
                </div> */}
              </div>
              
              <p>세이퍼트는 페이게이트에서 제공하는 핀테크 플랫폼입니다.</p>
              <p>세이퍼트는 가상계좌를 포함한 여러가지 집금 수단에 의해 충전할 수 있는 온라인 월렛을 의미합니다.</p>
              <p>세이퍼트 API를 통해 세이퍼트 간 월렛 간의 돈의 흐름을 요청 할 수 있습니다.</p>
            </div>

            <div className="kmItemGroup">
              <div className="kmItemBox">
                <h3>Recently Updated</h3>

                <div className="kmItemCont">
                  {recentData.map((key, i) =>
                    i < showDataNum &&
                    <KmList key={i} item={key} idx={i} showDataNum={showDataNum}/>
                  )}
                </div>
                
                <div className="recentlyBtn">
                  <button type="button" className="moreBtn" onClick={() => setShowDataNum(showDataNum + 5)}>더보기</button>
                  <button type="button" className="foldBtn" onClick={() => setShowDataNum(basicLimit)}>접기</button>
                </div>
              </div>

              {/* <div className="kmItemBox">
                <h3>Popular Topics</h3>

                <div className="kmItemCont">
                  <ul>
                    <li><Link to="">file-list</Link></li>
                    <li><Link to="">kb-how-to-article</Link></li>
                    <li><Link to="">cancel</Link></li>
                    <li><Link to="">documentation-space-sample</Link></li>
                    <li><Link to="">featured</Link></li>
                    <li><Link to="">fee</Link></li>
                    <li><Link to="">pending</Link></li>
                    <li><Link to="">transfer</Link></li>
                    <li><Link to="">공지</Link></li>
                    <li><Link to="">장애</Link></li>
                  </ul>
                </div>
              </div> */}
            </div>

            {/* <div className="fieldGroup">
              <label htmlFor="">Search this documentation</label>
            
              <div className="field">
                <div className="inputIco">
                  <input type="text" className="input lg round_10 i_rt" placeholder="Search this documentation" onChange={onChangeSearch} onKeyPress={onKeyPress}></input>
                  <i className="icofont-search" onClick={onSearch}></i>
                </div>
              </div>
            </div> */}
            
          </div>
        </div>
      </div>
    </>
  )
}

export default APIManual;